import { Component, OnInit, Inject } from '@angular/core';

import * as Tokens from '@shared/core/tokens';

@Component({
    selector: 'shared-bg-gradient',
    templateUrl: './bg-gradient.shared.component.html',
    styleUrls: ['./bg-gradient.shared.component.scss']
})
export class BgGradientComponent implements OnInit {
    public hasGradient: boolean = false;
    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
    ) { }

    ngOnInit(): void {
        this.hasGradient = this.config.ui && this.config.ui.heroBackground && this.config.ui.heroBackground.topGradient || false;
    }
}
